import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { ECadastralFieldsNames } from '../../types/reducers/rosreestrData';

export const CHECK_CADASTRAL_FIELDS_START = 'CADASTRAL_FIELDS :: CHECK_START';

export type TCheckCadastralFieldsStartAction = IReduxAction<
  typeof CHECK_CADASTRAL_FIELDS_START,
  Array<ECadastralFieldsNames>
>;

export const checkCadastralFieldsStart = actionGenerator<
  typeof CHECK_CADASTRAL_FIELDS_START,
  Array<ECadastralFieldsNames>
>(CHECK_CADASTRAL_FIELDS_START);
